module.exports = __webpack_public_path__ + "static/media/details-12-image-3.2a8c6d0e.jpg";